import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AtlasToastService } from './atlas-toast.service';

@Injectable()
export class EmailCreateTabManagerService {
  private obsTabIsReady = new Observable<any>();
  private obsSend = new Observable<any>();
  private subNext = new Subject<number>();
  private behaSubDone = new BehaviorSubject<any>(false);
  private behaSubBack = new BehaviorSubject<number>(0);
  private subStepChange = new Subject<number>();

  currentStep = 1;

  get lgBack$(): Subject<any> {
    return this.behaSubBack;
  }

  get lgNext$(): Observable<number> {
    return this.subNext.asObservable();
  }

  get lgDone$(): Observable<any> {
    return this.behaSubDone.asObservable();
  }

  get stepChange$(): Observable<any> {
    return this.subStepChange.asObservable();
  }

  get tabIsReady(): Observable<any> {
    return this.obsTabIsReady;
  }

  get send(): Observable<any> {
    return this.obsSend;
  }

  get step(): number {
    return this.currentStep;
  }

  setCurrentStep(step) {
    this.currentStep = step;
    this.subStepChange.next(this.currentStep);
  }

  setTabIsReady(obs) {
    this.obsTabIsReady = obs;
  }

  setSend(obs) {
    this.obsSend = obs;
  }

  lgNext() {
    this.subNext.next(this.currentStep);
  }

  lgDone(value?) {
    if (value) {
      this.behaSubDone.next(value);
    } else {
      this.behaSubDone.next(true);
    }
  }

  lgBack() {
    this.behaSubBack.next(this.currentStep);
  }

  constructor(private atlasToast: AtlasToastService) {}

  next() {
    this.currentStep++;
    this.subStepChange.next(this.currentStep);
  }

  back() {
    this.currentStep--;
    this.subStepChange.next(this.currentStep);
  }

  errorHandler(errorMessage: string, toastContainer) {
    if (errorMessage.includes('ContactManager returned negative recipients')) {
      return this.atlasToast.error('mail_invalid_recipients', null, 6000, toastContainer);
    } else if (errorMessage.includes('List Ids is empty for id Campaign Issue')) {
      return this.atlasToast.error('error_insertatleastonerecipient', null, 6000, toastContainer);
    } else if (errorMessage.includes('Invalid email hour purchase')) {
      return this.behaSubDone.next('SubError');
    } else {
      return this.atlasToast.error('common_error', null, 6000, toastContainer);
    }
  }
}
